import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { LucideAngularModule } from 'lucide-angular';

interface Tool {
	icon: string;
	title: string;
	description: string;
}

@Component({
	selector: 'app-tools-card',
	templateUrl: './tools-card.component.html',
	styleUrls: ['./tools-card.component.scss'],
	imports: [
		CommonModule,
		MatCardModule,
		MatIconModule,
		SharedModule,
		LucideAngularModule
	],
	standalone: true
})
export class ToolsCardComponent {
	tools: Tool[] = [
		{
			icon: 'chart-column',
			title: 'Guía de Implementación',
			description: 'Manual paso a paso'
		},
		{
			icon: 'graduation-cap',
			title: 'Capacitación',
			description: 'Curso de FAUBA'
		},
		{
			icon: 'image',
			title: 'Infografías',
			description: 'Material visual'
		},
		{
			icon: 'file-text',
			title: 'VISEC Brief',
			description: 'Resumen ejecutivo'
		},
		{
			icon: 'shield',
			title: 'Preguntas Frecuentes',
			description: 'Encuentra respuestas rápidas'
		}
	];
}
